import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { DisconnectedSaleComponent } from './disconnected-sale.component';
import { IdentificationComponent } from './identification/identification.component';
import { SuccessComponent } from './success/success.component';
import { PaymentComponent } from './payment/payment.component';

const disconnectedSaleRoutes: Routes = [
  { 
    path: '', 
    component: DisconnectedSaleComponent,
    children: [
      {
        path: 'identificacao', 
        component: IdentificationComponent,
      },
      {
        path: 'sucesso', 
        component: SuccessComponent,
      },
      {
        path: 'pagamento', 
        component: PaymentComponent,
      }
    ] 
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(disconnectedSaleRoutes)
  ],
  exports: [RouterModule]
})
export class DisconnectedSaleRoutingModule { }
